import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MapView from "./pages/MapView";
import {
  getMapRequestApi,
  postMapRequestFilterApi,
} from "services/mapCenter/mapCenter.thunks";
import { alertActions } from "_store";
import { ERR_MSG } from "constants/labels";
import { loadFiltersFromLocalStore } from "_utils/searchFilterLocalStorage";

export const MapCenter = () => {
  const dispatch = useDispatch();
  const authUser = useSelector((x) => x.auth?.value);
  const user = authUser?.Data;
  const userAccess = user?.UserAccess;
  const userdetails = user?.UserDetails;
  const isMCUserExpired = userdetails?.Status === "Expired";
  const isMCUserPartiallyApproved =
    userdetails?.Status === "Partially Approved";
  const isMCUserPartiallyVerified =
    userdetails?.Status === "Partially Verified";
  const isAdmin = userAccess?.some((access) =>
    access.Role.toLowerCase().includes("admin"),
  );
  const [mapRequestList, setMapRequestList] = useState([]);
  const [succeededFalseErrMsg, setSucceededFalseErrMsg] = useState(
    ERR_MSG["073"],
  );
  const [filterParams, setFilterParams] = useState(() =>
    loadFiltersFromLocalStore("mapCenterMapRequestList"),
  );

  useEffect(() => {
    let isCancelled = false;

    const run = async () => {
      try {
        if (
          isMCUserExpired ||
          isMCUserPartiallyApproved ||
          isMCUserPartiallyVerified
        ) {
          return;
        }

        const response = await dispatch(
          filterParams
            ? postMapRequestFilterApi(filterParams)
            : getMapRequestApi(),
        ).unwrap();

        if (isCancelled) return;

        const { Data, Succeeded, Message } = response;
        setMapRequestList(Succeeded ? Data : []);
        !Succeeded && setSucceededFalseErrMsg(Message);
      } catch (error) {
        if (isCancelled) return;

        dispatch(
          alertActions.error({
            message: succeededFalseErrMsg || error?.message,
          }),
        );
      }
    };

    run();

    return () => {
      isCancelled = true;
    };
  }, [
    dispatch,
    filterParams,
    isMCUserExpired,
    isMCUserPartiallyApproved,
    isMCUserPartiallyVerified,
    succeededFalseErrMsg,
  ]);

  return (
    <MapView
      isAdmin={isAdmin}
      mapRequestList={mapRequestList}
      setMapRequestList={setMapRequestList}
      filterParams={filterParams}
      setFilterParams={setFilterParams}
    />
  );
};
